module.exports = __webpack_public_path__ + "img/webSessions 1.c6742da7.png";